import { Check } from '@mui/icons-material';
import { Button, colors, Paper } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';

export default function QuizProgressOverall(props) {
   

    const progresses = () => {
        let progressItems = [];

        for (let i=0; i < props.max; i++) {
            if (i < props.n_finished) {
                progressItems.push(
                    <Paper key={i}
                        sx={{
                            height: "1rem",
                            mr: {xs: 0.5, sm: 1},
                            width: "100%",
                            backgroundColor: "secondary.main",
                        }}
                    ><Check sx={{color: colors.grey[700], height: "100%"}}/></Paper>
                )
            } else {
                if (props.n_finished === 0) {
                    progressItems.push(
                        <Paper key={i} 
                            sx={{
                                height: "1rem",
                                mr: {xs: 0.5, sm: 1},
                                width: "100%",
                                backgroundColor: grey[300],
                            }}
                        />
                    )
                } else {
                    progressItems.push(
                        <Paper key={i} 
                            sx={{
                                height: "1rem",
                                mr: {xs: 0.5, sm: 1},
                                width: "100%",
                                backgroundColor: "secondary.lightest",
                            }}
                        />
                    )
                }
            }   
        }

        return progressItems;
    }

    return(
        <Button sx={{display: "flex", width: "100%", mt: 1, mb: 1}}>
            {progresses()}
        </Button>
    )
}